import _some from "lodash/some";
import _includes from "lodash/includes";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import moment from 'moment';
import { AuthProviders } from "../constants";
/**
 * Redux selectors
 * @module Redux Selectors
 * @example
 * import { isPending } from @nerdwallet/jsauth-tools/selectors;
 * const state = store.getState();
 *
 * console.log(isPending(state.identity))
 * > true
 */

export var hasBasicInfo = function hasBasicInfo(identity) {
  return !_isEmpty(identity.temp.basicInfo);
};
export var isEmailVerified = function isEmailVerified(identity) {
  return !!_get(identity, 'current.verified_at');
};
export var showSMSStep = function showSMSStep(identity) {
  return _get(identity.smsVerification, 'smsCodeStep');
};
export var isSMSVerified = function isSMSVerified(identity) {
  return _get(identity.smsVerification, 'successfullyVerified');
};
export var needsSMSVerification = function needsSMSVerification(identity) {
  return _get(identity.smsVerification, 'verificationRequired');
};
export var antiFraudDecision = function antiFraudDecision(identity) {
  var _identity$antiFraud;

  return identity === null || identity === void 0 ? void 0 : (_identity$antiFraud = identity.antiFraud) === null || _identity$antiFraud === void 0 ? void 0 : _identity$antiFraud.antiFraudDecision;
};
export var getTUDuplicateEmail = function getTUDuplicateEmail(identity) {
  return _get(identity.temp, 'duplicateEmail');
};
export var hasTUDuplicateEmail = function hasTUDuplicateEmail(identity) {
  return !!getTUDuplicateEmail(identity);
};
export var isSecurityQuestionSet = function isSecurityQuestionSet(identity) {
  var roles = _get(identity, 'current.roles', []);

  return _includes(roles, 'nerdwallet/has_security_challenge');
};
export var getHasActivatedTransunion = function getHasActivatedTransunion(identity) {
  var roles = _get(identity, 'current.roles', []);

  return _includes(roles, 'nerdwallet/has_activated_transunion');
};
export var getHasPassedCaptcha = function getHasPassedCaptcha(identity) {
  var roles = _get(identity, 'current.roles', []);

  return _includes(roles, 'nerdwallet/has_passed_captcha');
};
export var hasRequestsPending = function hasRequestsPending(identity) {
  return _some(identity.requests, function (req, key) {
    // apple/google auth are special cases. Since we don't know whether the user may have closed
    // the popup oAuth window we don't consider it as a pending request
    if (_includes(['authenticateWithGoogle', 'authenticateWithApple'], key)) return false;
    return req.hasPendingRequests;
  });
};
export var getHasPasswordAuth = function getHasPasswordAuth(identity) {
  return _includes(_get(identity, 'current.auth_providers'), AuthProviders.NERDWALLET);
};
export var getHasGoogleAuth = function getHasGoogleAuth(identity) {
  return _includes(_get(identity, 'current.auth_providers'), AuthProviders.GOOGLE);
};
export var getHasAppleAuth = function getHasAppleAuth(identity) {
  return _includes(_get(identity, 'current.auth_providers'), AuthProviders.APPLE);
};
export var isSignedIn = function isSignedIn(identity) {
  return identity.isSignedIn;
};
export var getCreditSimulator = function getCreditSimulator(identity) {
  return _get(identity, 'creditSimulator');
};
export var getRecommendations = function getRecommendations(identity) {
  return _get(identity, 'recommendations');
};
export var getCreditHistory = function getCreditHistory(identity) {
  return _get(identity, 'creditHistory');
};
export var getRegisteredWithinPastDays = function getRegisteredWithinPastDays(identity) {
  var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var createdDate = moment(_get(identity, 'current.created_at'));
  return createdDate.isSameOrAfter(moment().subtract(days, 'days'));
};
export var getRegisteredWithinPastDay = function getRegisteredWithinPastDay(identity) {
  return getRegisteredWithinPastDays(identity, 1);
};
export var getRemainingSigninAttempts = function getRemainingSigninAttempts(identity) {
  return _get(identity, 'flags.signinAttemptsRemaining');
};
export * from "./auth";
export * from "./banking";
export * from "./credit-score";
export * from "./debt";
export * from "./financial-data";
export * from "./flows";
export * from "./my-bills";
export * from "./profiles";
export * from "./requests";
export * from "./tracking";
export * from "./transunion";
export * from "./visitor-data";
export * from "./yodlee";